import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import Leaderboard from './components/Leaderboard';
import NFTCollection from './components/NFTCollection';
import Profile from './components/Profile';
import Sutra from './components/Sutra';
import { LayoutDashboard, Trophy, LogOut, TreePine, Globe, Coins, Menu, X, Package, BarChart3, LayoutGrid, User, MessageCircle, Wheat, Warehouse, Droplets, Zap, ShoppingCart, Play } from 'lucide-react';

type View = 'dashboard' | 'leaderboard' | 'collection' | 'profile' | 'sutra' | 'apps';

const AppContent: React.FC = () => {
  const [showAuth, setShowAuth] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [currentView, setCurrentView] = useState<View>('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [appsMenuOpen, setAppsMenuOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  // Track page views for in-app navigation
  useEffect(() => {
    // Fire-and-forget increment request (no waiting for response)
    fetch('https://adi.ahantravyuh.com/vibuddh-api/visits/increment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }).catch(() => {}); // Silent fail
  }, [currentView]);

  const handleForestClick = () => {
    window.location.href = '/atavi/';
  };

  const handleWaahanClick = () => {
    window.location.href = '/waahan/';
  };

  const handleAhantClick = () => {
    window.location.href = '/ahant/';
  };

  const handleGarudClick = () => {
    window.location.href = '/garud/';
  };

  const handleVanijyaClick = () => {
    window.location.href = '/vanijya/';
  };

  const handleVidyutClick = () => {
    window.location.href = '/vidyut/';
  };

  const handleSelvamClick = () => {
    window.location.href = '/selvam/';
  };

  const handleAnnapoornaClick = () => {
    window.location.href = '/annapoorna/';
  };

  const handleBhandarClick = () => {
    window.location.href = '/bhandar/';
  };

  const handleWariClick = () => {
    window.location.href = '/wari/';
  };

  const handleDravyaClick = () => {
    window.location.href = '/dravya/';
  };

  const handleHanumanClick = () => {
    window.location.href = '/hanuman/';
  };

  const handleHelicopterClick = () => {
    window.location.href = '/helicopter/';
  };

  const handleTrainClick = () => {
    window.location.href = '/train/';
  };

  const handleShipClick = () => {
    window.location.href = '/ship/';
  };

  const handlePlaneClick = () => {
    window.location.href = '/plane/';
  };

  const handleJetClick = () => {
    window.location.href = '/jet/';
  };

  const handleKhanijClick = () => {
    window.location.href = '/khanij/';
  };

  const handleMedhiniClick = () => {
    window.location.href = '/medhini/';
  };

  const handleForumClick = () => {
    window.location.href = '/forum/';
  };

  const handleRamakrishnaClick = () => {
    window.location.href = '/ramakrishna/';
  };

  const handleChaturangClick = () => {
    window.location.href = '/chaturang/';
  };

  const handleVrihiClick = () => {
    window.location.href = '/vrihi/';
  };

  const handlePadavaliClick = () => {
    window.location.href = '/padavali/';
  };

  const handleDrishmanClick = () => {
    window.location.href = '/drishman/';
  };

  const handleSashrayiClick = () => {
    window.location.href = '/sashrayi/';
  };

  const handleAapanamClick = () => {
    window.location.href = '/aapanam/';
  };

  const handleAyvakamClick = () => {
    window.location.href = '/ayvakam/';
  };

  const handleJanayitriClick = () => {
    window.location.href = '/janayitri/';
  };

  const handleKridaClick = () => {
    window.location.href = '/krida/';
  };

  const handleKuralClick = () => {
    window.location.href = '/kural/';
  };

  const handleMaanchitraClick = () => {
    window.location.href = '/maanchitra/';
  };

  const handleNakshatraClick = () => {
    window.location.href = '/nakshatra/';
  };

  const handleUshnaClick = () => {
    window.location.href = '/ushna/';
  };

  const handleVizhiClick = () => {
    window.location.href = '/vizhi/';
  };

  const handleAgriledClick = () => {
    window.location.href = '/agriled/';
  };

  const handleAtharvavedaClick = () => {
    window.location.href = '/atharvaveda/';
  };

  const handleBanglaClick = () => {
    window.location.href = '/bangla/';
  };

  const handleChitraguptClick = () => {
    window.location.href = '/chitragupt/';
  };

  const handleCvClick = () => {
    window.location.href = '/cv/';
  };

  const handleDhanwantariClick = () => {
    window.location.href = '/dhanwantari/';
  };

  const handleDootaClick = () => {
    window.location.href = '/doota/';
  };

  const handleGateClick = () => {
    window.location.href = '/gate/';
  };

  const handleGhatikaClick = () => {
    window.location.href = '/ghatika/';
  };

  const handleGyanodbhawClick = () => {
    window.location.href = '/gyanodbhaw/';
  };

  const handleRigvedaClick = () => {
    window.location.href = '/rigveda/';
  };

  const handleRtudhwajClick = () => {
    window.location.href = '/rtudhwaj/';
  };

  const handleSamvedaClick = () => {
    window.location.href = '/samveda/';
  };

  const handleScotiotClick = () => {
    window.location.href = '/scotiot/';
  };

  const handleShankhyaravaClick = () => {
    window.location.href = '/shankhyarava/';
  };

  const handleSpandanClick = () => {
    window.location.href = '/spandan/';
  };

  const handleUyirClick = () => {
    window.location.href = '/uyir/';
  };

  const handleVedClick = () => {
    window.location.href = '/ved/';
  };

  const handleYajurvedaClick = () => {
    window.location.href = '/yajurveda/';
  };

  // Show Landing Page when not authenticated and auth not requested
  if (!isAuthenticated && !showAuth) {
    return (
      <LandingPage
        onLogin={() => {
          setShowAuth(true);
          setShowRegister(false);
        }}
        onRegister={() => {
          setShowAuth(true);
          setShowRegister(true);
        }}
      />
    );
  }

  // Show Login/Register when auth is requested
  if (!isAuthenticated && showAuth) {
    if (showRegister) {
      return <Register onSwitchToLogin={() => setShowRegister(false)} />;
    }
    return <Login onSwitchToRegister={() => setShowRegister(true)} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      {/* Navigation Bar */}
      <nav className="bg-white bg-opacity-10 backdrop-blur-lg border-b border-white border-opacity-20 relative z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-white">AhantraVyuh</h1>
            </div>

            {/* Desktop Nav Links - Smart Responsive */}
            <div className="hidden lg:flex items-center space-x-2">
              {/* Primary Navigation - Always visible */}
              <button
                onClick={() => setCurrentView('dashboard')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'dashboard'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <LayoutDashboard className="w-4 h-4" />
                <span>Dashboard</span>
              </button>
              <button
                onClick={() => setCurrentView('collection')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'collection'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <Package className="w-4 h-4" />
                <span>Collection</span>
              </button>
              <button
                onClick={() => setCurrentView('leaderboard')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'leaderboard'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <Trophy className="w-4 h-4" />
                <span>Leaderboard</span>
              </button>
              <button
                onClick={() => setCurrentView('sutra')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'sutra'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <MessageCircle className="w-4 h-4" />
                <span>Sutra</span>
              </button>
              <button
                onClick={() => setCurrentView('profile')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'profile'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <User className="w-4 h-4" />
                <span>Profile</span>
              </button>
              <button
                onClick={() => setCurrentView('apps')}
                className={`px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'apps'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <LayoutGrid className="w-4 h-4" />
                <span>Apps</span>
              </button>

              {/* Show Forest on XL+ screens */}
              <button
                onClick={handleForestClick}
                className="hidden xl:flex px-4 py-2 rounded-lg transition-all items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30"
              >
                <TreePine className="w-4 h-4" />
                <span>🌲 Forest</span>
              </button>

              {/* Show Waahan on 2XL+ screens */}
              <button
                onClick={handleWaahanClick}
                className="hidden 2xl:flex px-4 py-2 rounded-lg transition-all items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30"
              >
                <Globe className="w-4 h-4" />
                <span>🌊 Waahan</span>
              </button>

              {/* Apps Dropdown - Shows apps that don't fit */}
              <div className="relative">
                <button
                  onClick={() => setAppsMenuOpen(!appsMenuOpen)}
                  className="px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-white bg-opacity-5 border border-white border-opacity-20"
                >
                  <LayoutGrid className="w-4 h-4" />
                  <span>Apps</span>
                </button>

                {/* Apps Dropdown Menu */}
                {appsMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-gray-900 bg-opacity-95 backdrop-blur-lg rounded-lg shadow-xl border border-white border-opacity-20 py-2 z-[100]">
                    {/* Forest in dropdown on LG-XL screens */}
                    <button
                      onClick={() => {
                        handleForestClick();
                        setAppsMenuOpen(false);
                      }}
                      className="xl:hidden w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <TreePine className="w-4 h-4" />
                      <span>🌲 Forest</span>
                    </button>
                    {/* Waahan in dropdown below 2XL */}
                    <button
                      onClick={() => {
                        handleWaahanClick();
                        setAppsMenuOpen(false);
                      }}
                      className="2xl:hidden w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Globe className="w-4 h-4" />
                      <span>🌊 Waahan</span>
                    </button>
                    {/* AHANT - Always in dropdown */}
                    <button
                      onClick={() => {
                        handleAhantClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Coins className="w-4 h-4" />
                      <span>💰 AHANT</span>
                    </button>
                    {/* Garud - Always in dropdown */}
                    <button
                      onClick={() => {
                        handleGarudClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <span className="text-lg">🤖</span>
                      <span>Garud</span>
                    </button>
                    {/* Vanijya - Always in dropdown */}
                    <button
                      onClick={() => {
                        handleVanijyaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <BarChart3 className="w-4 h-4" />
                      <span>🏢 Vanijya</span>
                    </button>
                    {/* VIDYUT - Always in dropdown */}
                    <button
                      onClick={() => {
                        handleVidyutClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <span className="text-lg">⚡</span>
                      <span>VIDYUT</span>
                    </button>
                    {/* Selvam - Currency Trading */}
                    <button
                      onClick={() => {
                        handleSelvamClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Coins className="w-4 h-4" />
                      <span>💱 Selvam</span>
                    </button>
                    {/* Annapoorna - Commodity Trading */}
                    <button
                      onClick={() => {
                        handleAnnapoornaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Wheat className="w-4 h-4" />
                      <span>🌾 Annapoorna</span>
                    </button>
                    {/* Bhandar - Warehouse Management */}
                    <button
                      onClick={() => {
                        handleBhandarClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Warehouse className="w-4 h-4" />
                      <span>📦 Bhandar</span>
                    </button>
                    {/* WARI - Water Cleanup */}
                    <button
                      onClick={() => {
                        handleWariClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Droplets className="w-4 h-4" />
                      <span>💧 WARI</span>
                    </button>
                    {/* DRAVYA - Element Sort */}
                    <button
                      onClick={() => {
                        handleDravyaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>⚗️ DRAVYA</span>
                    </button>
                    {/* HANUMAN - Endless Runner */}
                    <button
                      onClick={() => {
                        handleHanumanClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🏃 HANUMAN</span>
                    </button>
                    {/* HELICOPTER - Flying Runner */}
                    <button
                      onClick={() => {
                        handleHelicopterClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🚁 HELICOPTER</span>
                    </button>
                    {/* TRAIN - Rail Runner */}
                    <button
                      onClick={() => {
                        handleTrainClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🚂 TRAIN</span>
                    </button>
                    {/* SHIP - Sailing Game */}
                    <button
                      onClick={() => {
                        handleShipClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>⛵ SHIP</span>
                    </button>
                    {/* PLANE - Commercial Plane Game */}
                    <button
                      onClick={() => {
                        handlePlaneClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>✈️ PLANE</span>
                    </button>
                    {/* JET - Jet Fighter Game */}
                    <button
                      onClick={() => {
                        handleJetClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🚀 JET</span>
                    </button>
                    {/* KHANIJ - Mining */}
                    <button
                      onClick={() => {
                        handleKhanijClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>⛏️ KHANIJ</span>
                    </button>
                    {/* MEDHINI - 3D Graphics */}
                    <button
                      onClick={() => {
                        handleMedhiniClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🌍 MEDHINI</span>
                    </button>
                    {/* FORUM - Discussion */}
                    <button
                      onClick={() => {
                        handleForumClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>💬 FORUM</span>
                    </button>
                    {/* RAMAKRISHNA - Historical Figures */}
                    <button
                      onClick={() => {
                        handleRamakrishnaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🙏 RAMAKRISHNA</span>
                    </button>
                    {/* CHATURANG - Chess */}
                    <button
                      onClick={() => {
                        handleChaturangClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>♟️ CHATURANG</span>
                    </button>
                    {/* VRIHI - Agriculture */}
                    <button
                      onClick={() => {
                        handleVrihiClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🌾 VRIHI</span>
                    </button>
                    {/* PADAVALI - Vocabulary */}
                    <button
                      onClick={() => {
                        handlePadavaliClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>📝 PADAVALI</span>
                    </button>
                    {/* DRISHMAN - Vision/Analysis */}
                    <button
                      onClick={() => {
                        handleDrishmanClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>👁️ DRISHMAN</span>
                    </button>
                    {/* SASHRAYI - Freelance */}
                    <button
                      onClick={() => {
                        handleSashrayiClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>💼 SASHRAYI</span>
                    </button>
                    {/* AAPANAM - Marketplace */}
                    <button
                      onClick={() => {
                        handleAapanamClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <ShoppingCart className="w-4 h-4" />
                      <span>🛒 AAPANAM</span>
                    </button>
                    {/* AYVAKAM - Ayurvedic */}
                    <button
                      onClick={() => {
                        handleAyvakamClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🌿 AYVAKAM</span>
                    </button>
                    {/* JANAYITRI - Creator */}
                    <button
                      onClick={() => {
                        handleJanayitriClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🎨 JANAYITRI</span>
                    </button>
                    {/* KRIDA - Games */}
                    <button
                      onClick={() => {
                        handleKridaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🎮 KRIDA</span>
                    </button>
                    {/* KURAL - Voice/Video Calls */}
                    <button
                      onClick={() => {
                        handleKuralClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>📞 KURAL</span>
                    </button>
                    {/* MAANCHITRA - Maps */}
                    <button
                      onClick={() => {
                        handleMaanchitraClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🗺️ MAANCHITRA</span>
                    </button>
                    {/* NAKSHATRA - Stars/Astro */}
                    <button
                      onClick={() => {
                        handleNakshatraClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>⭐ NAKSHATRA</span>
                    </button>
                    {/* USHNA - Weather/Heat */}
                    <button
                      onClick={() => {
                        handleUshnaClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Zap className="w-4 h-4" />
                      <span>🌡️ USHNA</span>
                    </button>
                    <button
                      onClick={() => {
                        handleVizhiClick();
                        setAppsMenuOpen(false);
                      }}
                      className="w-full px-4 py-2 text-left text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 flex items-center space-x-2"
                    >
                      <Play className="w-4 h-4" />
                      <span>📹 VIZHI</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Mobile Menu Button & User Info */}
            <div className="flex items-center space-x-2">
              <div className="text-right hidden sm:block">
                <p className="text-white font-medium text-sm">{user?.name}</p>
                <p className="text-gray-300 text-xs">{user?.email}</p>
              </div>
              <button
                onClick={logout}
                className="px-3 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors flex items-center space-x-2"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Logout</span>
              </button>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="lg:hidden px-3 py-2 text-white hover:bg-white hover:bg-opacity-10 rounded-lg transition-colors"
              >
                {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu Dropdown */}
          {mobileMenuOpen && (
            <div className="lg:hidden pb-4 space-y-2">
              <button
                onClick={() => {
                  setCurrentView('dashboard');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'dashboard'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <LayoutDashboard className="w-4 h-4" />
                <span>Dashboard</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('collection');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'collection'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <Package className="w-4 h-4" />
                <span>Collection</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('leaderboard');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'leaderboard'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <Trophy className="w-4 h-4" />
                <span>Leaderboard</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('sutra');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'sutra'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <MessageCircle className="w-4 h-4" />
                <span>Sutra</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('profile');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'profile'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <User className="w-4 h-4" />
                <span>Profile</span>
              </button>
              <button
                onClick={() => {
                  setCurrentView('apps');
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 ${
                  currentView === 'apps'
                    ? 'bg-white bg-opacity-20 text-white shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <LayoutGrid className="w-4 h-4" />
                <span>Apps</span>
              </button>
              <button
                onClick={() => {
                  handleForestClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-400/30"
              >
                <TreePine className="w-4 h-4" />
                <span>🌲 Forest</span>
              </button>
              <button
                onClick={() => {
                  handleWaahanClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30"
              >
                <Globe className="w-4 h-4" />
                <span>🌊 Waahan</span>
              </button>
              <button
                onClick={() => {
                  handleAhantClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-400/30"
              >
                <Coins className="w-4 h-4" />
                <span>💰 AHANT</span>
              </button>
              <button
                onClick={() => {
                  handleGarudClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-red-500/20 to-orange-500/20 border border-red-400/30"
              >
                <span className="text-lg">🤖</span>
                <span>Garud</span>
              </button>
              <button
                onClick={() => {
                  handleVanijyaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 border border-indigo-400/30"
              >
                <BarChart3 className="w-4 h-4" />
                <span>🏢 Vanijya</span>
              </button>
              <button
                onClick={() => {
                  handleVidyutClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-yellow-500/20 to-amber-500/20 border border-yellow-400/30"
              >
                <span className="text-lg">⚡</span>
                <span>VIDYUT</span>
              </button>
              <button
                onClick={() => {
                  handleSelvamClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-teal-500/20 to-cyan-500/20 border border-teal-400/30"
              >
                <Coins className="w-4 h-4" />
                <span>💱 Selvam</span>
              </button>
              <button
                onClick={() => {
                  handleAnnapoornaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-amber-600/20 to-orange-500/20 border border-amber-500/30"
              >
                <Wheat className="w-4 h-4" />
                <span>🌾 Annapoorna</span>
              </button>
              <button
                onClick={() => {
                  handleBhandarClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-slate-500/20 to-blue-500/20 border border-slate-400/30"
              >
                <Warehouse className="w-4 h-4" />
                <span>📦 Bhandar</span>
              </button>
              <button
                onClick={() => {
                  handleWariClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-400/30"
              >
                <Droplets className="w-4 h-4" />
                <span>💧 WARI</span>
              </button>
              <button
                onClick={() => {
                  handleDravyaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>⚗️ DRAVYA</span>
              </button>
              <button
                onClick={() => {
                  handleHanumanClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-orange-500/20 to-red-500/20 border border-orange-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🏃 HANUMAN</span>
              </button>
              <button
                onClick={() => {
                  handleHelicopterClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-sky-500/20 to-blue-500/20 border border-sky-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🚁 HELICOPTER</span>
              </button>
              <button
                onClick={() => {
                  handleTrainClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-gray-500/20 to-slate-500/20 border border-gray-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🚂 TRAIN</span>
              </button>
              <button
                onClick={() => {
                  handleShipClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-blue-600/20 to-cyan-500/20 border border-blue-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>⛵ SHIP</span>
              </button>
              <button
                onClick={() => {
                  handlePlaneClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-sky-500/20 to-indigo-500/20 border border-sky-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>✈️ PLANE</span>
              </button>
              <button
                onClick={() => {
                  handleJetClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-red-600/20 to-orange-500/20 border border-red-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🚀 JET</span>
              </button>
              <button
                onClick={() => {
                  handleKhanijClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-stone-500/20 to-amber-500/20 border border-stone-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>⛏️ KHANIJ</span>
              </button>
              <button
                onClick={() => {
                  handleMedhiniClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-emerald-500/20 to-teal-500/20 border border-emerald-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🌍 MEDHINI</span>
              </button>
              <button
                onClick={() => {
                  handleForumClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-violet-500/20 to-purple-500/20 border border-violet-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>💬 FORUM</span>
              </button>
              <button
                onClick={() => {
                  handleRamakrishnaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-orange-500/20 to-amber-500/20 border border-orange-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🙏 RAMAKRISHNA</span>
              </button>
              <button
                onClick={() => {
                  handleChaturangClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-slate-500/20 to-gray-500/20 border border-slate-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>♟️ CHATURANG</span>
              </button>
              <button
                onClick={() => {
                  handleVrihiClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-lime-500/20 to-green-500/20 border border-lime-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🌾 VRIHI</span>
              </button>
              <button
                onClick={() => {
                  handlePadavaliClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-rose-500/20 to-pink-500/20 border border-rose-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>📝 PADAVALI</span>
              </button>
              <button
                onClick={() => {
                  handleDrishmanClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-blue-500/20 to-indigo-500/20 border border-blue-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>👁️ DRISHMAN</span>
              </button>
              <button
                onClick={() => {
                  handleSashrayiClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 border border-amber-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>💼 SASHRAYI</span>
              </button>
              <button
                onClick={() => {
                  handleAapanamClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-emerald-500/20 to-green-500/20 border border-emerald-400/30"
              >
                <ShoppingCart className="w-4 h-4" />
                <span>🛒 AAPANAM</span>
              </button>
              <button
                onClick={() => {
                  handleAyvakamClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-green-600/20 to-emerald-500/20 border border-green-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🌿 AYVAKAM</span>
              </button>
              <button
                onClick={() => {
                  handleJanayitriClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-pink-500/20 to-rose-500/20 border border-pink-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🎨 JANAYITRI</span>
              </button>
              <button
                onClick={() => {
                  handleKridaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-purple-500/20 to-violet-500/20 border border-purple-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🎮 KRIDA</span>
              </button>
              <button
                onClick={() => {
                  handleKuralClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border border-blue-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>📞 KURAL</span>
              </button>
              <button
                onClick={() => {
                  handleMaanchitraClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-teal-500/20 to-cyan-500/20 border border-teal-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🗺️ MAANCHITRA</span>
              </button>
              <button
                onClick={() => {
                  handleNakshatraClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 border border-indigo-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>⭐ NAKSHATRA</span>
              </button>
              <button
                onClick={() => {
                  handleUshnaClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-orange-500/20 to-red-500/20 border border-orange-400/30"
              >
                <Zap className="w-4 h-4" />
                <span>🌡️ USHNA</span>
              </button>
              <button
                onClick={() => {
                  handleVizhiClick();
                  setMobileMenuOpen(false);
                }}
                className="w-full px-4 py-2 rounded-lg transition-all flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 bg-gradient-to-r from-pink-500/20 to-purple-500/20 border border-pink-400/30"
              >
                <Play className="w-4 h-4" />
                <span>📹 VIZHI</span>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Main Content */}
      {currentView === 'dashboard' && <Dashboard />}
      {currentView === 'collection' && <NFTCollection token={localStorage.getItem('token') || ''} />}
      {currentView === 'profile' && <Profile />}
      {currentView === 'sutra' && <Sutra />}
      {currentView === 'leaderboard' && (
        <Leaderboard
          token={localStorage.getItem('token') || ''}
          currentUserId={user?.ahn_id}
        />
      )}
      {currentView === 'apps' && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">All Applications</h2>
            <p className="text-gray-300">Access all Ahantravyuh platform applications</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Agriled */}
            <div
              onClick={handleAgriledClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🌾</div>
              <h3 className="text-xl font-bold text-white mb-2">AgriLED</h3>
              <p className="text-gray-300 text-sm">Agricultural LED solutions</p>
            </div>

            {/* Atharvaveda */}
            <div
              onClick={handleAtharvavedaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📖</div>
              <h3 className="text-xl font-bold text-white mb-2">Atharvaveda</h3>
              <p className="text-gray-300 text-sm">Ancient knowledge system</p>
            </div>

            {/* Bangla */}
            <div
              onClick={handleBanglaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📰</div>
              <h3 className="text-xl font-bold text-white mb-2">Bangla</h3>
              <p className="text-gray-300 text-sm">Bengali news & articles</p>
            </div>

            {/* Chitragupt */}
            <div
              onClick={handleChitraguptClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📊</div>
              <h3 className="text-xl font-bold text-white mb-2">Chitragupt</h3>
              <p className="text-gray-300 text-sm">Record keeper & analytics</p>
            </div>

            {/* CV */}
            <div
              onClick={handleCvClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📄</div>
              <h3 className="text-xl font-bold text-white mb-2">CV Builder</h3>
              <p className="text-gray-300 text-sm">Professional resume creator</p>
            </div>

            {/* Dhanwantari */}
            <div
              onClick={handleDhanwantariClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">⚕️</div>
              <h3 className="text-xl font-bold text-white mb-2">Dhanwantari</h3>
              <p className="text-gray-300 text-sm">Health & wellness platform</p>
            </div>

            {/* Doota */}
            <div
              onClick={handleDootaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📧</div>
              <h3 className="text-xl font-bold text-white mb-2">Doota</h3>
              <p className="text-gray-300 text-sm">Secure email messenger</p>
            </div>

            {/* Gate */}
            <div
              onClick={handleGateClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🚪</div>
              <h3 className="text-xl font-bold text-white mb-2">Gate</h3>
              <p className="text-gray-300 text-sm">Access control system</p>
            </div>

            {/* Ghatika */}
            <div
              onClick={handleGhatikaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">⏰</div>
              <h3 className="text-xl font-bold text-white mb-2">Ghatika</h3>
              <p className="text-gray-300 text-sm">Time tracking & alarms</p>
            </div>

            {/* Gyanodbhaw */}
            <div
              onClick={handleGyanodbhawClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🎓</div>
              <h3 className="text-xl font-bold text-white mb-2">Gyanodbhaw</h3>
              <p className="text-gray-300 text-sm">Knowledge awakening</p>
            </div>

            {/* Rigveda */}
            <div
              onClick={handleRigvedaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📜</div>
              <h3 className="text-xl font-bold text-white mb-2">Rigveda</h3>
              <p className="text-gray-300 text-sm">Vedic knowledge base</p>
            </div>

            {/* Rtudhwaj */}
            <div
              onClick={handleRtudhwajClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🌤️</div>
              <h3 className="text-xl font-bold text-white mb-2">Rtudhwaj</h3>
              <p className="text-gray-300 text-sm">Seasonal indicators</p>
            </div>

            {/* Samveda */}
            <div
              onClick={handleSamvedaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🎵</div>
              <h3 className="text-xl font-bold text-white mb-2">Samveda</h3>
              <p className="text-gray-300 text-sm">Musical knowledge system</p>
            </div>

            {/* Scotiot */}
            <div
              onClick={handleScotiotClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🔌</div>
              <h3 className="text-xl font-bold text-white mb-2">ScotIoT</h3>
              <p className="text-gray-300 text-sm">IoT monitoring system</p>
            </div>

            {/* Shankhyarava */}
            <div
              onClick={handleShankhyaravaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🔢</div>
              <h3 className="text-xl font-bold text-white mb-2">Shankhyarava</h3>
              <p className="text-gray-300 text-sm">Advanced calculations</p>
            </div>

            {/* Spandan */}
            <div
              onClick={handleSpandanClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">💓</div>
              <h3 className="text-xl font-bold text-white mb-2">Spandan</h3>
              <p className="text-gray-300 text-sm">Health monitoring</p>
            </div>

            {/* Uyir */}
            <div
              onClick={handleUyirClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🌺</div>
              <h3 className="text-xl font-bold text-white mb-2">Uyir</h3>
              <p className="text-gray-300 text-sm">Life essence platform</p>
            </div>

            {/* Ved */}
            <div
              onClick={handleVedClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">📚</div>
              <h3 className="text-xl font-bold text-white mb-2">Ved</h3>
              <p className="text-gray-300 text-sm">Vedic library system</p>
            </div>

            {/* Yajurveda */}
            <div
              onClick={handleYajurvedaClick}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20 hover:bg-opacity-20 hover:scale-105 transition-all cursor-pointer"
            >
              <div className="text-4xl mb-4">🔥</div>
              <h3 className="text-xl font-bold text-white mb-2">Yajurveda</h3>
              <p className="text-gray-300 text-sm">Ritual knowledge base</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
